import React, { memo, forwardRef } from "react";
const SvgForwardSlash = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M10.634 25.187a1 1 0 01-.366-1.366l10-17.32A1 1 0 0122 7.5L12 24.82a1 1 0 01-1.366.366z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgForwardSlash.displayName = "SvgForwardSlash";
const MemoForwardRef = memo(SvgForwardSlash);
export default MemoForwardRef;
